<mat-card>
  <mat-card-content>
    <div class="flex gap-4 justify-center">
      <div>
        <app-site-detail-tilt-drawing-viewer
          *ngIf="site"
          [site]="site"
        ></app-site-detail-tilt-drawing-viewer>
      </div>
    </div>
  </mat-card-content>
</mat-card>
